import { render, staticRenderFns } from "./project-work-orders.vue?vue&type=template&id=b92b81c4"
import script from "./project-work-orders.vue?vue&type=script&lang=js"
export * from "./project-work-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports